<script>
export default {
  props: {
    heading: { type: String, required: true },
    items: { type: Array, required: true },
    quantityFromItemFunc: { type: Function, required: true },
    packedQuantityFromItemFunc: { type: Function, required: true },
    quantitiesEditable: { type: Boolean, required: true },
    showPacked: { type: Boolean, required: true },
  },

  methods: {
    onClickEditQuantity(item) {
      this.$emit('edit-item-quantity', item);
    },
  },
}
</script>

<template>
  <table>
    <thead>
      <tr>
        <td colspan="20" class="text-center">
          <h4> {{heading}} </h4>
        </td>
      </tr>
      <tr>
        <th>Type</th>
        <th>Qty</th>
        <th v-if="showPacked">Packed</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="item in items" :key="item.id"
        :class="{
           'bg-danger text-light': showPacked && packedQuantityFromItemFunc(item) < quantityFromItemFunc(item),
           'bg-success text-light': showPacked && quantityFromItemFunc(item) > 0 && packedQuantityFromItemFunc(item) === quantityFromItemFunc(item)}">
        <td>
          {{item.type.display_name}}
        </td>
        <td :class="{'clickable' : quantitiesEditable}" @click="onClickEditQuantity(item)">
          {{quantityFromItemFunc(item)}}
        </td>
        <td v-if="showPacked">
          {{packedQuantityFromItemFunc(item)}}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
td.clickable:hover {
  background-color: #b0b8c0;
}
</style>



// WEBPACK FOOTER //
// src/sales/components/EggOrderQuantityTable.vue